export const BrancheFlorale = ({ className = '' }: { className?: string }) => (
  <svg viewBox="0 0 220 56" className={className} fill="none" aria-hidden="true">
    <path d="M8 48 Q 62 42 110 30 T 212 10" stroke="#8C9478" strokeWidth="1.1" />
    <ellipse cx="46" cy="41" rx="9" ry="3.6" fill="#A8BBD4" opacity="0.6" transform="rotate(-18 46 41)" />
    <ellipse cx="78" cy="35" rx="8" ry="3.2" fill="#7E92B4" opacity="0.5" transform="rotate(-14 78 35)" />
    <ellipse cx="128" cy="26" rx="9" ry="3.6" fill="#A8BBD4" opacity="0.6" transform="rotate(-12 128 26)" />
    <ellipse cx="162" cy="20" rx="7" ry="3" fill="#DCE5EF" opacity="0.9" transform="rotate(-10 162 20)" />
    <g transform="translate(196 12)">
      <ellipse cx="0" cy="-6" rx="3.4" ry="6" fill="#7E92B4" opacity="0.65" />
      <ellipse cx="5.5" cy="-1.5" rx="3.4" ry="6" fill="#A8BBD4" opacity="0.65" transform="rotate(72)" />
      <ellipse cx="3.5" cy="5" rx="3.4" ry="6" fill="#7E92B4" opacity="0.5" transform="rotate(144)" />
      <ellipse cx="-3.5" cy="5" rx="3.4" ry="6" fill="#A8BBD4" opacity="0.6" transform="rotate(216)" />
      <ellipse cx="-5.5" cy="-1.5" rx="3.4" ry="6" fill="#DCE5EF" opacity="0.9" transform="rotate(288)" />
      <circle cx="0" cy="0" r="2" fill="#2B3A63" opacity="0.7" />
    </g>
    <ellipse cx="100" cy="33" rx="4" ry="1.8" fill="#8C9478" opacity="0.5" transform="rotate(-16 100 33)" />
  </svg>
);

export const FleurCoin = ({ className = '' }: { className?: string }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <g transform="translate(24 24)">
      <ellipse cx="0" cy="-9" rx="5" ry="9" fill="#A8BBD4" opacity="0.55" />
      <ellipse cx="8.5" cy="-2.8" rx="5" ry="9" fill="#7E92B4" opacity="0.45" transform="rotate(72)" />
      <ellipse cx="5.3" cy="7.3" rx="5" ry="9" fill="#A8BBD4" opacity="0.5" transform="rotate(144)" />
      <ellipse cx="-5.3" cy="7.3" rx="5" ry="9" fill="#DCE5EF" opacity="0.85" transform="rotate(216)" />
      <ellipse cx="-8.5" cy="-2.8" rx="5" ry="9" fill="#7E92B4" opacity="0.4" transform="rotate(288)" />
      <circle cx="0" cy="0" r="3" fill="#2B3A63" opacity="0.65" />
    </g>
  </svg>
);
